"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IN = void 0;
exports.IN = {
    alias: 'VALORES_EM',
    description: 'Busca uma correspondência exata do {texto} dentro da {lista_de_caracteres}. Retorna true se achar uma correspondência, e false caso contrário',
    arg_names: ['texto', 'lista_de_caracteres'],
    args_description: [
        'Texto a buscar correspondência',
        'Lista a ser procurada (em texto), separando valores por vírgula, ou JSON array em string',
    ],
};
